import React, { useEffect, useState, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss?v=2.0.0";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import store from "./store";
import { getSettings } from "./Redux/settingsReduce";
import LoginPage from "./views/Settings/User/LoginPage";
import ResetPassword from "./views/Settings/User/ResetPassword";
import jwt_decode from "jwt-decode";
import { getDetailUser } from "./Redux/usersReduce";
import RootBase from "./RootBase";
import {
  setLanguage,
  setDefaultTranslations,
  setDefaultLanguage,
} from "react-multi-lang";
import en from "./views/utils/en.json";
import fr from "./views/utils/fr.json";
import Main from "./Main";
import Layout from "./Layout";
import Deconnexion from "./views/Deconnexion";
import Profile from "./views/Profile";

const root = ReactDOM.createRoot(document.getElementById("root"));
var token = localStorage.getItem("x-access-token");

setDefaultTranslations({ fr, en });
setDefaultLanguage("fr");
let lang = window.localStorage.getItem("lang");
if (lang) setLanguage(lang);
else window.localStorage.setItem("lang", "fr");

let testLogin = 0;



function AppWrapper() {
  const [view, setView] = useState(localStorage.getItem("view") || "");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);  // ⏳ add loading state

useEffect(() => {
		async function init() {
			try {
				store.dispatch(getSettings(1));
			} catch (error) {
				console.log("settings", error);
			}

			if (token !== null) {
				try {
					const decoded = jwt_decode(token);
					testLogin = 1;
					if (decoded.id) {
						try {
						const response = await store.dispatch(getDetailUser(decoded.id));
            
            if(response.payload.logout==true){
              localStorage.clear();
						window.location.replace("/login");
            }else{
              setUserData(response.payload);
               setLoading(false); 
            }
						// ✅ set userData here
						// ✅ mark loading complete
						} catch (error) {
						localStorage.clear();
						window.location.replace("/login");
}
	} else {
		localStorage.clear();
		window.location.replace("/login");
	}
	} catch (err) {
		console.log("ici")
		console.error("Error decoding token:", err);
		localStorage.clear();
		window.location.replace("/login");
	}
	}
	setLoading(false);

	}

	init();
	}, []);

  const mainRoutes = [
    { path: "/", name: "Home", icon: "fas fa-home", className: "", role: [20] },
    { path: "/profile", name: "Mon Profil", icon: "fas fa-user", className: "", role: [20], component: "Profile" },
    { path: "/Deconnexion", name: "Déconnexion", icon: "nc-icon nc-button-power", className: "", role: [20], component: "Deconnexion" },
  ];

  if (loading) {
    return <div class="loader-container">
      <div class="loader"></div>
    </div>;  // ⏳ show loading spinner or screen
  }



  return (
    <BrowserRouter>
      {testLogin === 0 ? (
        <Switch>
          <Route path="/login" render={() => <LoginPage />} />
          <Route path="/resetPassword/:code" render={() => <ResetPassword />} />
          <Redirect from="/" to="/login" />
        </Switch>
      ) : (
        <Switch>

          <Route
            path="/medis"
            render={() =>
              userData?.data.id_site.includes("2") && view != "" ? (
                <Suspense fallback={<div class="loader-container">
                  <div class="loader"></div>
                </div>}>
                  <RootBase client="medis" view={view} />
                </Suspense>

              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/neapolis"
            render={() =>
              userData?.data.id_site.includes("3") && view != "" ? (
                <Suspense fallback={<div class="loader-container">
                  <div class="loader"></div>
                </div>}>
                  <RootBase client="neapolis" view={view} />
                </Suspense>

              ) : (
                <Redirect to="/" />
              )
            }
          />



          <Route exact path="/">
            <Layout routes={mainRoutes}>
              <Main obj={userData?.data} setView={setView} />
            </Layout>
          </Route>
          <Redirect from="/home" to="/" />
          <Route
            path={[
              "/*",
              "/",
              "/profile",
              "/Deconnexion"
            ]}
            render={() => (
              <Layout routes={mainRoutes}>
                <Switch>
                  <Route exact path="/" render={() => <Main obj={userData?.data} setView={setView} />} />
                  {userData && (<Route
                    path="/profile"
                    render={(props) => <Profile {...props} obj={userData?.data} />}
                  />)}
                  <Route path="/Deconnexion" component={Deconnexion} />
                  <Route exact path="/*" render={() => <Main obj={userData?.data} setView={setView} />} />
                </Switch>
              </Layout>
            )}
          />

        </Switch>
      )}
    </BrowserRouter>
  );
}

root.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>
);
